Wee.routes.map({
	'we-see-a-teacher': {
		'$slug': [
			'common',
			'landingPage2',
			'form',
			'newsletter',
			'quotes',
			'modal',
			function() {
				$('ref:form').csrf(),
				$('ref:newsletter').csrf();
			}
		]
	}
});

Wee.ready('routes:run');
